// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put } from 'redux-saga/effects';
import { setLoaderState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import PAYMENT_CONSTANTS from '../Payment.constants';
import {
  getCardList,
  updateCardListonDeleteErr,
  setDeleteModalMountedState,
  clearCardBalance,
  setPaymentNotification,
} from './Payment.actions';
import { getAddressList } from '../../AddressBook/container/AddressBook.actions';
import {
  deleteCardApi,
  removeCustomerGiftCard,
} from '../../../../../services/abstractors/account/DeleteCard';
import { getUserInfo } from '../../User/container/User.actions';
import BAG_PAGE_ACTIONS from '../../../CnC/BagPage/container/BagPage.actions';
import { showErrorInModal } from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';

export function* deleteCard({ payload }) {
  yield put(setLoaderState(true));
  try {
    const res = yield call(
      payload.ccType.toLowerCase() === 'giftcard' ? removeCustomerGiftCard : deleteCardApi,
      payload
    );
    yield put(setLoaderState(false));
    if (res?.statusCode === 200) {
      yield put(getCardList({ ignoreCache: true }));
      yield put(setDeleteModalMountedState({ state: false }));
      yield put(setPaymentNotification({ status: 'success' }));
      if (payload.ccType.toLowerCase() === 'giftcard') {
        yield put(clearCardBalance(payload));
      } else {
        yield put(getAddressList({ ignoreCache: true }));
      }
      yield put(getUserInfo({ ignoreCache: true }));
      yield put(BAG_PAGE_ACTIONS.getNonCachedCartData());
    } else {
      yield put(updateCardListonDeleteErr(res.error));
    }
  } catch (err) {
    yield put(setLoaderState(false));
    yield put(showErrorInModal());
    yield put(updateCardListonDeleteErr(err));
  }
}

export function* DeleteCardSaga() {
  yield takeLatest(PAYMENT_CONSTANTS.DELETE_CARD, deleteCard);
}

export default DeleteCardSaga;
